
import { string } from 'yup/lib/locale';
import { Environment } from '../../../environment';
import { Api } from "../axios-config";

// dueDate/agencyNumber/pixKey eram snake_case aqui (due_date/agency_number/pix_key) mas o backend
// já manda camelCase pra este endpoint — mesmo padrão de IProvisionListBySinister, que funciona
// certo. Bug reportado: vencimento aparecia errado só na listagem do módulo Borderô isolado.
export interface IProvisionList {
    id?: string,
    sequencial:number,
    sinisterId: string,
    status: string,
    dueDate?: string,
    provisionedAt?: string,
    provisionedUser?: string,
    value?: string,
    createdAt?: string,
    updatedAt?: string,
    paymentValue?: string,
    paymentAt?: string,
    paymentUser?: string,
    clientId?: string,
    peopleId?: string,
    agencyNumber?: string,
    bankCode?: string,
    agencyDigit?: string,
    accountNumber?: string,
    accountDigit?: string,
    pixKey?: string,
    pixKeyType?: string,
    email?: string,
    canceledReason?: string,
    canceledAt?: string,
    canceledUser?: string,
    limitedAt?: string,
    // Status novo "suspenso" (item 6/14 do GARV2-1463/1464) — endpoint ainda não devolve estes
    // campos, ver GAPS_BORDERO_PARA_BACKEND.md.
    suspendedReason?: string,
    suspendedBy?: "sinistro" | "financeiro",
    suspendedAt?: string,
    // Data agendada pro lançamento no banco (item 16) — não confundir com scheduledAt (a marcação
    // em si, que ainda não existe no backend); esta é a data que o Financeiro escolhe ao agendar.
    scheduledDate?: string,
    indemnityWorksheet?: string,
    client:{
        name:string,
        document:string,
        trade_name:string,
    },
    sinister:{
        status: string,
		busyProperty: string,
        proposal:{
            document:string,
            name:string,
            email:string,
            phone:string,
        }
    }
}
export interface IProvisionListBySinister {
    id:string,
    sequencial:number,
    sinisterId:string,
    status:string,
    dueDate:string,
    provisionedAt:string,
    provisionedUser:string,
    value:string,
    createdAt:string,
    updatedAt:string,
    paymentValue:string,
    paymentAt:string,
    paymentUser:string,
    clientId:string,
    peopleId:string,
    agencyNumber:string,
    bankCode:string,
    agencyDigit:string,
    accountNumber:string,
    accountDigit:string,
    pixKey:string,
    pixKeytYpe:string,
    email:string,
    canceledReason:string,
    canceledAt:string,
    canceledUser:string,
    // Status novo "suspenso" (item 6/14) — endpoint ainda não devolve, ver GAPS_BORDERO_PARA_BACKEND.md.
    suspendedReason?: string,
    suspendedBy?: "sinistro" | "financeiro",
    suspendedAt?: string,
    scheduledDate?: string,
    indemnityWorksheet?: string,
}
type TProvisionTotalCount = {
    data: IProvisionList[];
    totalCount: number;
}

type TProvisionBySinisterTotalCount = {
    data: IProvisionListBySinister[];
    totalCount: number;
}


export interface IBorderoPayment {
    // clientId: string;
    // dueDate: string;
    // provisionedAt?: string;
    paymentAt:string;
    paymentValue: string;
    //id: string;
    // gateway?: "EMPTY",
    // status?: "pending",
}

// cancelType: "erro" | "real" — item 13 (GARV2-1463/1464): ao cancelar, distinguir se foi engano
// (permite os débitos voltarem a ficar disponíveis pra um novo borderô) de um cancelamento
// intencional de verdade.
export interface IFormCancel {
    canceledReason: string;
    cancelType?: "erro" | "real";
  }

  export interface IBorderoProvision {
    provisionedAt?: string;
}

// Suspender/retirar suspensão (item 6/14) — endpoints ainda não existem no backend, ver
// GAPS_BORDERO_PARA_BACKEND.md. Motivo é opcional ao suspender, mas obrigatório ao retirar.
// `origin` é explícito porque o mesmo endpoint é chamado tanto pelo Sinistro (aba Valores) quanto
// pelo Financeiro (módulo /bordero) — o backend não tem como saber quem chamou só pela rota, e
// precisa gravar isso em suspendedBy pra fazer valer a regra de prevalência do item 14.
export interface IBorderoSuspend {
    origin: "sinistro" | "financeiro";
    reason?: string;
}

export interface IBorderoLiftSuspension {
    reason: string;
    dueDate: string;
}

// Agendar (item 16) — endpoint ainda não existe no backend, ver GAPS_BORDERO_PARA_BACKEND.md. Só o
// Financeiro aciona. scheduledDate é a data em que o lançamento no banco está programado —
// precisa ficar salva pra aparecer na tabela (pedido explícito: saber a data agendada, não só o
// status).
export interface IBorderoSchedule {
    origin: "financeiro";
    scheduledDate: string;
}

// Editar dados bancários depois de criado (item 4) — endpoint ainda não existe, contrato sugerido
// no gap doc (PATCH /provision/:id/bank-data). Mesmos campos do payload de geração.
export interface IBorderoBankData {
    bankCode?: string;
    agencyNumber?: string;
    agencyDigit?: string;
    accountNumber?: string;
    accountDigit?: string;
    accountType?: "corrente" | "poupanca";
    pixKey?: string;
    pixKeyType?: string;
}

// export interface IBorderoPayment {
//     clientId: string;
//     dueDate: string;
//     value: string;
//     id: string;
//     gateway?: "EMPTY",
//     status?: "pending",
// }
//const getAllBorderoById = async (page = 1, busca = '', status = '', dataini = '', datafim = ''): Promise<TProvisionTotalCount | Error> => {
const getAllBorderoById = async (sinisterId = ''): Promise< TProvisionBySinisterTotalCount | Error> => {
    try {
        const urlRelativa = `/provision/sinister/${sinisterId}`;
        const { data, headers } = await Api().get(urlRelativa);
        if (data.results) {
            return {
                data: data.results,
                totalCount: data.total,
            };
        }
        return new Error('Erro ao listar registros.');
    } catch (error) {
        console.error(error);
        return new Error((error as { message: string }).message || 'Erro ao listar registros.');
    }
};

                            //pagina, busca, tipoBordero, statusAnalise, dataIniBordero, dataFimBordero, clientFilter
const getAllBordero = async (page = 1, busca = '', tipo ='',status = '', typePeriod ='',dataini = '', datafim = '', clientFilter=''): Promise<TProvisionTotalCount | Error> => {
    try {                            
        const urlRelativa = `/provision?_page=${page}&_limit=${Environment.LIMITE_LINHAS_GREAT}&nome_like=${busca}&tipo=${tipo}&status=${status}&typePeriod=${typePeriod}&dataini=${dataini}&datafim=${datafim}&clientId=${clientFilter}`
        console.log(urlRelativa);
        const { data, headers } = await Api().get(urlRelativa);
        if (data.results) {
            console.log('?all Bordero....', data)
            return {
                data: data.results,
                totalCount: data.total,
            };
        }
        return new Error('Erro ao listar registros.');
    } catch (error) {
        console.error(error);
        return new Error((error as { message: string }).message || 'Erro ao listar registros.');
    }
};

const cancelBordero = async (id:string, dados:IFormCancel): Promise<IBorderoPayment | Error> =>{
    try {                            
        const urlRelativa = `/provision/${id}`
        const { data, headers } = await Api().put(urlRelativa,dados);
        if (data.results) {
            return data.results
        }
        return new Error('Erro ao listar registros.');
    } catch (error) {
        console.error(error);
        return new Error((error as { message: string }).message || 'Erro ao listar registros.');
    }

} 



const borderoPayment = async (id: string, dados: IBorderoPayment): Promise<void | Error> => {
    try {
        await Api().patch(`/provision/pagamento/${id}`, dados);
    } catch (error) {
        console.error(error);
        return new Error((error as { message: string }).message || 'Erro ao cancelar o registro.');
    }
};


const borderoProvision = async (id: string, dados: IBorderoProvision): Promise<void | Error> => {
    try {
        await Api().patch(`/provision/provisionar/${id}`, dados);
    } catch (error) {
        console.error(error);
        return new Error((error as { message: string }).message || 'Erro ao cancelar o registro.');
    }
};


const borderoCancel = async (id: string, dados: IFormCancel): Promise<void | Error> => {
    try {
        await Api().patch(`/provision/cancelar/${id}`, dados);
    } catch (error) {
        console.error(error);
        return new Error((error as { message: string }).message || 'Erro ao cancelar o registro.');
    }
};

// borderoSuspend/borderoLiftSuspension — endpoints ainda não existem no backend (pedido
// formalizado, ver GAPS_BORDERO_PARA_BACKEND.md). Suspender é acionável tanto pelo setor de
// Sinistro quanto pelo Financeiro (módulo próprio) — dados.origin diz qual dos dois.
const borderoSuspend = async (id: string, dados: IBorderoSuspend): Promise<void | Error> => {
    try {
        await Api().patch(`/provision/suspender/${id}`, dados);
    } catch (error) {
        console.error(error);
        return new Error((error as { message: string }).message || 'Erro ao suspender o borderô.');
    }
};

// Agendar (item 16) — só o Financeiro aciona.
const borderoSchedule = async (id: string, dados: IBorderoSchedule): Promise<void | Error> => {
    try {
        await Api().patch(`/provision/agendar/${id}`, dados);
    } catch (error) {
        console.error(error);
        return new Error((error as { message: string }).message || 'Erro ao agendar o borderô.');
    }
};

// Só deve funcionar quando suspendedBy === "sinistro" — se o Financeiro suspendeu, o backend deve
// rejeitar (400) mesmo que o setor de Sinistro tente chamar este endpoint (regra de prevalência,
// item 14).
const borderoLiftSuspension = async (id: string, dados: IBorderoLiftSuspension): Promise<void | Error> => {
    try {
        await Api().patch(`/provision/retirar-suspensao/${id}`, dados);
    } catch (error) {
        console.error(error);
        return new Error((error as { message: string }).message || 'Erro ao retirar a suspensão do borderô.');
    }
};

const borderoUpdateBankData = async (id: string, dados: IBorderoBankData): Promise<void | Error> => {
    try {
        await Api().patch(`/provision/${id}/bank-data`, dados);
    } catch (error) {
        console.error(error);
        return new Error((error as { message: string }).message || 'Erro ao atualizar os dados bancários do borderô.');
    }
};

const countBordero = async (id: string): Promise<number | Error> => {
    try {
        const resultado = await Api().get(`/provision/count/${id}`);
       // console.log('teste 201 count provision....',resultado);
        return Number(resultado?resultado.data:'0')
    } catch (error) {
        console.error(error);
        return new Error((error as { message: string }).message || 'Erro ao cancelar o registro.');
    }
};


const getBorderoPDF = async (id: string, ) => { 
    try {

        const { data } = await Api().get(`/sinister-report/indenizacao/${id}`, { responseType: 'blob' });
        if (data) {
            const file = new Blob(
                [data],
                { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
        }
        //return new Error('Erro ao consultar o registro.');
    } catch (error) {
        console.error(error);
        return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
    }
};


export const ProvisionService = {
    getAllBorderoById,
    getAllBordero,
    borderoPayment,
    borderoProvision,
    borderoCancel,
    borderoSuspend,
    borderoSchedule,
    borderoLiftSuspension,
    borderoUpdateBankData,
    countBordero,
    getBorderoPDF,
};